import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

export default function CTA() {
    const { t } = useI18n();
    return (
        <section className="relative py-24 sm:py-28">
            <div className="mx-auto max-w-6xl px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="relative overflow-hidden rounded-3xl p-10 sm:p-16 border border-white/8"
                    style={{
                        background: "radial-gradient(ellipse at 20% 0%, rgba(99,102,241,0.35), transparent 55%), radial-gradient(ellipse at 100% 100%, rgba(6,182,212,0.28), transparent 55%), #14142a",
                    }}
                >
                    <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none" />
                    <div className="relative grid grid-cols-1 md:grid-cols-3 gap-10 items-center">
                        <div className="md:col-span-2">
                            <h3 className="font-display font-black text-3xl sm:text-5xl tracking-tighter text-white leading-[1.05]">
                                {t.landing.ctaBigTitle}
                            </h3>
                            <p className="mt-4 text-zinc-300 text-lg">{t.landing.ctaBigSub}</p>
                        </div>
                        <div className="md:justify-self-end">
                            <Link
                                to="/register"
                                data-testid="landing-cta-big"
                                className="btn-cta text-white font-semibold px-6 py-3.5 rounded-full inline-flex items-center gap-2"
                            >
                                {t.landing.ctaBigButton}
                                <ArrowUpRight size={18} />
                            </Link>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
